import React, { useRef } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

const DragDropContainer = styled('div')({
	border: '2px dashed #aaa',
	borderRadius: '5px',
	padding: '20px',
	textAlign: 'center',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: '#f9f9f9',
	},
});

const MultipleFileUpload = (props) => {
	const fileInputRef = useRef(null);

	const handleDragOver = (event) => {
		event.preventDefault();
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const newFiles = Array.from(event.dataTransfer.files);
		props.setFiles([...props.files, ...newFiles]);
	};

	const handleClick = () => {
		fileInputRef.current.click();
	};

	return (
		<div>
			<DragDropContainer
				onClick={handleClick}
				onDragOver={handleDragOver}
				onDrop={handleDrop}
			>
				<Typography variant='body1'>
					{props?.files?.length > 0 ? (
						<>Archivos subidos: {props?.files?.length}</>
					) : (
						<>Arrastra y suelta archivos aquí</>
					)}
				</Typography>
				<Typography variant='body2'>
					(o haz clic para seleccionar archivos)
				</Typography>
				<Typography variant='body2'>
					<b>Archivos permitidos: image/*, .pdf, .doc, .docx</b>
				</Typography>
			</DragDropContainer>
			<input
				type='file'
				ref={fileInputRef}
				onChange={props.handleFileChange}
				style={{ display: 'none' }}
				multiple
				accept='image/*, .pdf, .doc, .docx'
			/>
			{props.uploading && (
				<CircularProgress
					variant='determinate'
					value={props.progress}
				/>
			)}
			{props.uploadError && (
				<Typography color='error'>{props.uploadError}</Typography>
			)}
		</div>
	);
};

export default MultipleFileUpload;
